import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chip } from '@siteground/styleguide';
import { removeFileForUpload } from '../../actions/file-upload';
import { getPendingFileForUpload } from '../../selectors/file-upload';
import './file-upload-chip.css';

const FileUploadChip = () => {
  const file = useSelector(getPendingFileForUpload);
  const dispatch = useDispatch();

  if (!file) {
    return null;
  }

  return (
    <div className="message-box__file-upload-wrapper">
      <Chip onDelete={() => dispatch(removeFileForUpload())}>{file.name}</Chip>
    </div>
  );
};

export default FileUploadChip;
